import React from 'react';
import { Component, createRef } from 'react';
import {Link,hashHistory} from 'react-router-dom';
import './styles.css'

class FigureItem extends React.Component {

  
  constructor(props) {
    super(props);
    this.state={
      visible: false,
    }
    
  }
  //Se invoca inmediatamente después de que un componente se monte (se inserte en el árbol)
  componentDidMount() {
    //this.setState({show: aux});
    console.log("did mount");
    
  }
  handleClick=(e)=>{
    // 👇️ Use event.preventDefault() if you want to
    // prevent navigation
    e.preventDefault();
    /*let obj = {id_mate: this.props.id_mate,
      nombre: this.props.nombre,
      sigla: this.props.sigla,
    }*/
    //----pasa el item, compeltito totalmente
    this.props.onClick();
  }
  
  //---------------------------------------------------------------------
  render() {
    
    console.log(this.props.message);
    
    //let display = this.props.show ==true? 'block':'none';

    const message = this.props.message;
    //const alertClassName = `alert ${ this.alertClass(message.type) } alert-dismissible fade show`;
    //-- imgSrc
    //-- nombre

    return(
     
      <div>   
        <figure className="user-card green" style={{borderTop: '3px solid #3ecfac'}}>
          <figcaption> 
            <img  className="profile" 
                    src={this.props.imgSrc}
                    style={{ maxHeight: '180px'}} alt=""/>
            <h5> { this.props.nombre } </h5>
            {/*<!--<p>Viva el internet</p>-->*/}
            <div className="clearfix">
              <span className="badge badge-pill badge-info">ID={ this.props.id }</span> 
              {/*<span className="badge badge-pill badge-success">#resumen2</span> 
              <span className="badge badge-pill badge-orange">Insignias</span>*/}
            </div>
          </figcaption>
        </figure>
      </div>
    );
  }
}

/*NuAlert.propTypes = {
  onClose: React.PropTypes.func,
  timeout: React.PropTypes.number,
  message: React.PropTypes.object.isRequired
};*/

FigureItem.defaultProps = {
  imgSrc: '',
  nombre:'',
  id:0,
};

export default FigureItem;